/**
 * Gets a filename from a content-disposition header. If the filename cannot be
 * parsed a fallback will be returned.
 * @param contentDisposition The content-disposition header
 * @param fallback The fallback if the filename cannot be parsed
 * @return The filename
 */
function getFileNameFromContentDisposition(
  contentDisposition?: string,
  fallback?: string,
): string {
  try {
    return contentDisposition!.split('filename="')[1].split('"')[0];
  } catch (e) {
    return fallback ?? 'file';
  }
}

export default getFileNameFromContentDisposition;
